<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter, RouterView } from 'vue-router';
import { DxDrawer } from 'devextreme-vue/drawer';
import { DxToolbar, DxItem as DxToolbarItem } from 'devextreme-vue/toolbar';
import { DxButton } from 'devextreme-vue/button';
import { authService, env } from '@botto/core';
import { menuStore } from './menu';
import SideNav from './SideNav.vue';
import Breadcrumbs from './Breadcrumbs.vue';

const drawerOpened = ref(true);
const route = useRoute();
const router = useRouter();

const currentSection = computed(() => {
  const path = route.path;
  for (const s of menuStore.sections) {
    if (path.startsWith(`/${s.id}`)) return s;
  }
  return null;
});

const displayName = computed(() => authService.getDisplayName() || 'Пользователь');

async function logout() {
  await authService.logout();
  await router.push({ name: 'login' });
}

watch(
  () => route.path,
  () => {
    /* keep drawer state; could auto-close on mobile here */
  },
);
</script>

<template>
  <div class="botto-app">
    <DxToolbar class="botto-toolbar">
      <DxToolbarItem location="before" widget="dxButton">
        <DxButton icon="menu" styling-mode="text" @click="drawerOpened = !drawerOpened" />
      </DxToolbarItem>
      <DxToolbarItem location="before">
        <RouterLink to="/" class="botto-brand">
          SMPP Router<span class="botto-brand__mvp">MVP</span>
        </RouterLink>
      </DxToolbarItem>
      <DxToolbarItem location="center">
        <span v-if="currentSection" class="botto-section-title">{{ currentSection.title }}</span>
      </DxToolbarItem>
      <DxToolbarItem v-if="env.authEnabled" location="after">
        <div class="botto-user">
          <span class="botto-user__name">{{ displayName }}</span>
          <DxButton text="Выход" styling-mode="text" @click="logout" />
        </div>
      </DxToolbarItem>
    </DxToolbar>

    <DxDrawer
      class="botto-drawer"
      :opened="drawerOpened"
      :open-state-mode="'shrink'"
      :reveal-mode="'expand'"
      :position="'left'"
      :min-size="0"
      :max-size="240"
      :template="'sidenav'"
      :close-on-outside-click="false"
    >
      <template #sidenav>
        <SideNav :sections="menuStore.visibleSections" />
      </template>

      <div class="botto-page-host">
        <Breadcrumbs />
        <div class="botto-router-host">
          <RouterView />
        </div>
      </div>
    </DxDrawer>
  </div>
</template>

<style scoped>
.botto-drawer { flex: 1 1 auto; min-height: 0; }
.botto-router-host {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 16px 16px;
  background: var(--botto-color-bg);
}
.botto-page-host { display: flex; flex-direction: column; height: 100%; min-height: 0; }
.botto-user {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 4px;
}
.botto-user__name {
  font-size: 13px;
  color: var(--botto-color-text-muted, #5a6478);
}
</style>
